import axios from "axios";
import { APP_CONFIGURATION_KEYS, DEFAULT_PAGE_INDEX, MAX_PAGE_SIZE } from "../../utils/Constant";
import { paramsConfig, urlParamsConfig } from "../../utils/ParamsUtils";
import { SearchObject } from "../models/PhanHeTiepNhanModel";
import { localStorageItem } from "../../utils/LocalStorage";
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
import { IInPhieuParams } from "../../models/params";
import { OctResponse } from "../../models/OctResponse";
import { InsuranceVerifyParams } from "../models/TiepDonModel";


const API_PATH = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.API_URL] || process.env.REACT_APP_API_URL;
const API_PATH_ADMINISTRATION = process.env.REACT_APP_ADMIN_API_URL;
const API_PATH_BENH_NHAN = API_PATH + "/patients";
const API_PATH_TIEP_DON = API_PATH + "/admission";
const API_PATH_CLINICAL = process.env.REACT_APP_CIS_API_URL;
const API_PATH_XADMIN = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.ADMIN_URL] || process.env.REACT_APP_ADMIN_API_URL;
const API_PATH_INS = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.INS_URL] || process.env.REACT_APP_INS_API_URL;


export const searchByPage = (searchObject: SearchObject) => {
    let url = API_PATH_TIEP_DON + "/search";
    return axios.get(urlParamsConfig(url, searchObject));
};

export const getData = async (searchObject: any) => {
    let url = API_PATH_BENH_NHAN + '/search';
    return axios.get(urlParamsConfig(url, searchObject));
}

export const getPatientId = async (id: string) => {
    let url = API_PATH_BENH_NHAN + `/${id}`;
    return axios.get(url);
}

export const addBenhNhan = (data: any, callback?: (dataCb: any) => void) => {
    return axios.post(API_PATH_TIEP_DON, data, { callback });
};

export const updateBenhNhan = (data: any, callback?: (dataCb: any) => void) => {
    let url = API_PATH_TIEP_DON;
    return axios.put(url, data, { callback });
};

export const getBenhNhan = (searchObject: {
    code?: string;
    idNumber?: string;
}) => {
    let url = API_PATH_BENH_NHAN;
    return axios.get(urlParamsConfig(url, searchObject));
}

export const getByIdBenhNhan = (id: string) => {
    let url = API_PATH_TIEP_DON + `/${id}`;
    return axios.get(url);
}

export const getListDangKyKham = () => {
    let url = API_PATH + "/visit-types/search";
    return axios.get(url, { params: { pageSize: MAX_PAGE_SIZE } });
}

export const getListQuocTich = () => {
    let url = API_PATH_XADMIN + "/country/search";
    return axios.get(url, { params: { pageSize: MAX_PAGE_SIZE } });
}

export const getListDanToc = () => {
    let url = API_PATH_XADMIN + "/cEthnics/search";
    return axios.get(url, {
        params: {
            pageIndex: DEFAULT_PAGE_INDEX,
            pageSize: MAX_PAGE_SIZE,
        }
    });
}

//Nationalities
export const getAllNation = (searchObject: any) => {
    let url = API_PATH_ADMINISTRATION + "/nationalities";
    return axios.get(urlParamsConfig(url, searchObject));
}

export const getAllProvince = (searchObject: any) => {
    let url = API_PATH_ADMINISTRATION + "/provinces";
    return axios.get(urlParamsConfig(url, searchObject));
}

export const getDistrictByProvinceId = (searchObject: any) => {
    let url = API_PATH_ADMINISTRATION + '/districts'
    return axios.get(urlParamsConfig(url, searchObject));
}

export const getCommuneByDistrictId = (searchObject: any) => {
    let url = API_PATH_ADMINISTRATION + '/communes'
    return axios.get(urlParamsConfig(url, searchObject));
}

export const getAllCategory = (searchObject: any) => {
    let url = API_PATH_ADMINISTRATION + "/simple-category";
    return axios.get(urlParamsConfig(url, searchObject));
}


//Phong kham
export const getDSPhongKham = () => {
    let url = API_PATH + '/admission/department-info'
    return axios.get(url);
}

// Yêu cầu khám
export const getDanhSachYeuCauKham = () => {
    let url = API_PATH_CLINICAL + '/concepts/service/58'
    return axios.get(url)
}

//upload image
export const uploadImage = (patientId: string, formData: any) => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    let url = API_PATH_BENH_NHAN + `/benh-nhan/avatar?patientId=${patientId}`;
    return axios.post(url, formData, config)
}

// lich sử khám
export const getListSu = (patientId: string) => {
    let url = API_PATH + `/admission/medical-records/patient/${patientId}`
    return axios.get(url);
}

//Thông tin khám bệnh
export const getChiTietBenhNhan = (caseId: string, searchObject: any) => {
    let url = API_PATH_BENH_NHAN + `/benh-nhan/detail/${caseId}`
    return axios.get(url,paramsConfig(searchObject))
}

//DS tiếp nhận
export const getDSTiepNhan = (searchObject: any) => {
    let url = API_PATH_BENH_NHAN + '/benh-nhan/dang-kham';
    return axios.post(url,{}, paramsConfig(searchObject));
}


//FAKE API
const API_PATH_FAKE = "http://localhost:3000/"
export const addBenhNhanFake = (data: any) => {
    return axios.post(API_PATH_FAKE + 'tiep-nhan', data);
};
export const updateBenhNhanFake = (id: any,data: any) => {
    return axios.put(API_PATH_FAKE + 'tiep-nhan/'+ id, data);
};
export const getListBenhNhanFake = () => {
    return axios.get(API_PATH_FAKE + 'tiep-nhan');
};
export const getChiTietBenhNhanFake = (id: number, searchObject: any) => {
    let url = API_PATH_FAKE + `tiep-nhan/${id}`
    return axios.get(url,paramsConfig(searchObject))
}

export const deleteBenhNhanFake = (id: number) => {
    let url = API_PATH_FAKE + `tiep-nhan/${id}`
    return axios.delete(url)
};


export const deleteBenhNhan = async (encounterId: string) => {
    let url = API_PATH_TIEP_DON + `?encounterId=${encounterId}`;
    return axios.delete(url);
}

export const inPhieuKham = async(params: IInPhieuParams) => {
    return await axios.post<Blob>(
      `${API_PATH}/export/admission`,
      params, 
      {
        responseType: 'blob',
      }
    );
  };

  export const getListNguoiGioiThieu = (data: any) => {
    let url = API_PATH + `/obs-complex-categories/dmthemnguoigioithieu/search`;
    return axios.post(url, data);
}

export const getValueTextFormFieldConfig = (code: string) => {
    let url = API_PATH + `/wf-org-conf/${code}/value-text`;
    return axios.get(url);
}

export const verifyHealthInsurance = async (
	params: InsuranceVerifyParams
): Promise<OctResponse<any>> => {
    let url = API_PATH_INS + `/egw/lookup`;
	const { data } = await axios.post<OctResponse<any>>(
		url,
		params
	);
	return data;
};

export const getInsCoveragePercentage = (data: any) => {
    return axios.post(`${API_PATH_INS}/insurance/allowance-level/card`, data);
};

export const getHealthInsuranceCards = async (params: {
	visitId: string;
}): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(`${API_PATH}/insurances/search`, {
		params,
	});
    
	return data;
};

export const deleteHealthInsuranceCard = async (insId: number): Promise<OctResponse<any>> => {
    const { data } = await axios.delete<OctResponse<any>>(`${API_PATH}/visits/ins/${insId}`);
    return data;
};

export const createHealthInsuranceCard = async (payload: any, callback?: (dataCb: any) => void): Promise<OctResponse<any>> => {
    const { data } = await axios.post<OctResponse<any>>(`${API_PATH}/visits/ins`, payload, { callback });
    return data;
};

export const updateHealthInsuranceCard = async (insId: number, payload: any, callback?: (dataCb: any) => void): Promise<OctResponse<any>> => {
    const { data } = await axios.put<OctResponse<any>>(`${API_PATH}/visits/ins/${insId}`, payload, { callback });
    return data;
};

export const getInsLevel = (params: {
    insKcbbdCode?: string | number;
    visitType?: string | number;
    appointmentId?: string | number;
    ggtHospital?: string | number;
    patientId?: string;
}) => {
    return axios.get(`${API_PATH_INS}/insurance/ins-level`, { params });
};

export const updateVisitFields = (id: string, fields: Record<string, any>) => {
    let url = `${API_PATH}/visits/${id}/update-fields`;
    return axios.put(url, fields);
};